import React, { useEffect, useState } from 'react';
import OwnerRegistartionCard from './OwnerRegistrationList.jsx'
import OwnerParkinglotRegistration from './OwnerParkinglotRegistration.jsx';
import OwnerTeamMembers from './OwnerTeamMembers.jsx';
import './OwnerRegistration.css';
import MapDashboard from '../myproporties/MapDashboard';
import { GetUserDetailsFromToken } from '../../Services/employeeService.jsx';

const OwnerDetailsComponent = (props) => {
  const [userDetails] = useState([]);
  const [isEdit, setEdit] = useState();
  const [areasmarked, setAreasmarked] = useState([]);
  const [parkinglotObj, setParkinglotObj] = useState();
  const [defaultaddress, setDefaultaddress] = useState();
  const [editOption, setEditoption] = useState();
  const [salespersonloggedin, setSalespersonloggedin] = useState();
  const [activeMenuId, setActiveMenuId] = useState(null);
  const [employeeId,setEmployeeId] = useState();
  const [isEditingEmployee, setIsEditingEmployee] = useState(false);
  const [viewingEmployee, setViewingEmployee] = useState(null);

  const handleActiveMenuId = (val) => {
    setActiveMenuId(val);
  }

  const handleSetAreasMarked = (newAreas) => {
    setAreasmarked(newAreas);
  };

  const handleSetParkingLotObj = (newParkingLot) => {
    setParkinglotObj(newParkingLot);
  };

  const handleSetDefaultAddress = (newAddress) => {
    setDefaultaddress(newAddress);
  };

  const handleSetEditOption = (newEditOption) => {
    setEditoption(newEditOption);
  };
  const handleSetEdit = (val) => {
    setEdit(val);
  };

  const handleBack = () => {
    props.handleSelectedowner();
  };

  const mapUserData = viewingEmployee
    ? {
        ...props.selectedRow,
        ...viewingEmployee,
        entityRegistrationID: props.selectedRow?.entityRegistrationID,
        enityMailingAdderess: props.selectedRow?.enityMailingAdderess,
        empRegistrationID: viewingEmployee.empRegistrationID,
        empId: viewingEmployee.empId,
      }
    : props.selectedRow;

  useEffect(() => {
    const fetchUserData = async () => {
        try {
            const userData = await GetUserDetailsFromToken();
            setSalespersonloggedin(userData?.firstName);
            setEmployeeId(userData?.empId);
        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    };
    fetchUserData(); 
  }, []);

  useEffect(() => {
    if (!props.showTeamMembers) {
      setViewingEmployee(null);
      setIsEditingEmployee(false);
    }
  }, [props.showTeamMembers]); 
  return (
    <div>
      <div>
        {!isEdit ? (
          <div className='container-fluid p-0'>
            <div className="lotmanagement">
              <div className="row alignLeft">
                <div className="col-7">
                  <div className="viewHeader">
                    <button
                      className="backButton"
                      onClick={handleBack}
                      style={{
                        marginRight: '10px',
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer'
                      }}
                    >
                      <i className="fas fa-arrow-left"></i>
                    </button>
                    Manage Owners & Properties
                  </div>
                </div>               
              </div>
              {!props.selectedRow && (
                <div className="row alignLeft">
                  <div className="col-12 mb-2">
                    Total Registered Owners: {userDetails?.length}
                  </div>
                </div>
              )}
              {!isEditingEmployee && (
              <OwnerRegistartionCard
                ownerName={props.selectedRow?.firstName}
                entityName={props.selectedRow?.entityName}
                email={props.selectedRow?.emailId}
                entityId={props.selectedRow?.entityRegistrationID}
                mobilePhone={props.selectedRow?.mobileNumber}
                entityAddress={props.selectedRow?.enityMailingAdderess}
                handleSelectedowner={props.handleSelectedowner}
                propertyOwner={props.propertyOwner}
                handleEdit={props.handleEdit}
                handleDelete={props.handleDelete}
                handleRegsiterOwner={props.handleRegsiterOwner}
                handleManageTeamMembers={props.handleManageTeamMembers}
                property={props.selectedRow}
                activeMenuId={activeMenuId}
                onActiveMenuIdChange={handleActiveMenuId}
                isEmailPhoneVerified= {props.selectedRow?.isEmailPhoneVerified}
                isEmailVerified= {props.selectedRow?.isEmailVerified}
                isPhoneVerified= {props.selectedRow?.isPhoneVerified}
                isTempPassword= {props.selectedRow?.isTempPassword}
                tandC= {props.selectedRow?.tandC}
              />
              )}
              {props.showTeamMembers ? (
                <OwnerTeamMembers
                  entityId={props.selectedRow?.entityRegistrationID}
                  OwnerDetails={props.selectedRow}
                  handleEdit={props.handleEdit}
                  onEditEmployeeModeChange={setIsEditingEmployee}
                  viewingEmployee={viewingEmployee}
                  onViewingEmployeeChange={setViewingEmployee}
                  onSetAreasMarked={handleSetAreasMarked}
                  onSetParkingLotObj={handleSetParkingLotObj}
                  onSetDefaultAddress={handleSetDefaultAddress}
                  onSetEditOption={handleSetEditOption}
                  handleSetEdit={handleSetEdit}
                />
              ) : (
                <OwnerParkinglotRegistration
                  entityId={props.selectedRow?.entityRegistrationID}
                  onSetAreasMarked={handleSetAreasMarked}
                  onSetParkingLotObj={handleSetParkingLotObj}
                  onSetDefaultAddress={handleSetDefaultAddress}
                  onSetEditOption={handleSetEditOption}
                  handleSetEdit={handleSetEdit}
                  OwnerDetails={props.selectedRow}
                  handleEdit={props.handleEdit}
                />
              )}
            </div>
          </div>

        ) : (
          <div><MapDashboard isEdit={isEdit} areasMarked={areasmarked} defaultaddress={defaultaddress} parkinglotObj={parkinglotObj} editOption={editOption} empId={viewingEmployee?.empId || employeeId}
            empRegistrationID={viewingEmployee?.empRegistrationID}
            verifiedBy={salespersonloggedin} userData={mapUserData} mapVisibleChangesAlert={props.mapVisibleChangesAlert}
          /></div>
        )}
      </div>
    </div>
  );
};

export default OwnerDetailsComponent;
